import {
  ACCESS_REQUEST_GRANT_ACCESS,
  CLOSE_REQUEST_SUCCESS,
  FETCH_POSSIBLE_MATCHES,
  RECEIVE_MAGIC_PASSWORD,
  RECEIVE_NETWORK_ACCESS_REQUESTS,
  RECEIVE_POSSIBLE_MATCHES,
  REVERT_ACCESS_REQUEST_DRAWER,
  TURN_OFF_MEMBER_ACCESS_SAVING,
  UPDATE_ACCESS_REQUEST_ADD_MEMBER_DIALOG_OPEN,
  UPDATE_ACCESS_REQUEST_ERROR,
  UPDATE_CLOSED_REQUEST_IDS,
  UPDATE_MATCHED_CONSTITUENT_ID,
  UPDATE_SELECTED_ACCESS_REQUEST,
} from "@/components/access/admin/ducks/Actions"
import { LOGOUT } from "@/components/access/ducks/Actions"

const accessRequestDefaultState = {
  selectedAccessRequest: null,
  memberAccessLoading: false,
  matchedConstituentId: null,
  memberAccessSaving: false,
  accessRequestAddMemberDialogOpen: false,
  accessRequestError: "",
  addMemberIsForAccessRequest: false,
}

const defaultState = {
  accessRequestId: null,
  closedRequestIds: [],
  magicPassword: "",
  networkAccessRequests: [],
  networkAccessRequestsFetched: false,
  possibleMatches: [],
  ...accessRequestDefaultState,
}

const adminAccessReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_POSSIBLE_MATCHES:
      return {
        ...oldState,
        possibleMatches: action.possibleMatchDict.matches,
        accessRequestId: action.possibleMatchDict.accessRequestId,
        memberAccessLoading: false,
      }

    case REVERT_ACCESS_REQUEST_DRAWER:
      return {
        ...oldState,
        ...accessRequestDefaultState,
      }

    case FETCH_POSSIBLE_MATCHES:
      return {
        ...oldState,
        memberAccessLoading: true,
      }

    case TURN_OFF_MEMBER_ACCESS_SAVING:
      return {
        ...oldState,
        memberAccessSaving: false,
      }

    case UPDATE_ACCESS_REQUEST_ERROR:
      return {
        ...oldState,
        accessRequestError: action.error,
        memberAccessLoading: action.error ? false : oldState.memberAccessLoading,
      }

    case UPDATE_ACCESS_REQUEST_ADD_MEMBER_DIALOG_OPEN:
      return {
        ...oldState,
        accessRequestAddMemberDialogOpen: action.open,
        addMemberIsForAccessRequest: !!action.accessRequest,
      }

    case CLOSE_REQUEST_SUCCESS:
      return {
        ...oldState,
        memberAccessSaving: false,
      }

    case UPDATE_CLOSED_REQUEST_IDS:
      return {
        ...oldState,
        closedRequestIds: action.ids,
      }

    case UPDATE_SELECTED_ACCESS_REQUEST:
      return {
        ...oldState,
        selectedAccessRequest: action.selectedAccessRequest,
      }
    case UPDATE_MATCHED_CONSTITUENT_ID:
      return {
        ...oldState,
        matchedConstituentId: action.id,
      }

    case RECEIVE_NETWORK_ACCESS_REQUESTS:
      return {
        ...oldState,
        networkAccessRequests: action.networkAccessRequests,
        networkAccessRequestsFetched: true,
      }
    case ACCESS_REQUEST_GRANT_ACCESS:
      return {
        ...oldState,
        memberAccessSaving: true,
      }

    case RECEIVE_MAGIC_PASSWORD:
      return {
        ...oldState,
        magicPassword: action.magicPassword,
      }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default adminAccessReducer
